import React from 'react';
import { staticYearList } from '../model/StaticVariables';
import PreparedMaps from './PreparedMaps';

const ContentInformation = () => {
    const yrs = staticYearList.slice(0, staticYearList.length - 1);
    const yrStr = yrs.map((y) => y.label).join(', ');
    return (
        <div role="tabpanel" id="panel-information-inner">
            <div id="info-text">
                <h2>
                    SVI Interactive Map <br />
                    Help Documentation
                </h2>

                <p>
                    <i>Our suggested citation for use of the SVI Interactive Map:</i>
                </p>
                <blockquote>
                    Centers for Disease Control and Prevention/Agency for Toxic Substances and Disease Registry/Geospatial Research, Analysis, and Services Program. CDC/ATSDR Social Vulnerability Index Interactive Map <strong>[Insert {yrStr}, or 2000]</strong> Database <strong>[Insert US or State]</strong>. <strong>[url of the interactive map]</strong>. Accessed on <strong>[Insert date]</strong>.
                </blockquote>

                <h3>Additional Resources</h3>
                <p>
                    <span>Visit these links to learn more about the CDC/ATSDR Social Vulnerability Index:</span>
                </p>
                <ul>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/index.html" target="_blank">
                            SVI Home Page
                        </a>
                    </li>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/fact_sheet/fact_sheet.html" target="_blank">
                            SVI Fact Sheet
                        </a>
                    </li>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/data_documentation_download.html" target="_blank">
                            SVI Data and Documentation
                        </a>
                    </li>
                    <li>
                        <a href="https://www.atsdr.cdc.gov/placeandhealth/svi/faq_svi.html" target="_blank">
                            Frequently Asked Questions
                        </a>
                    </li>
                </ul>
                <a name="preparedcountymaps">
                    <h3>Prepared County Maps</h3>
                </a>
                <PreparedMaps />
                <p>
                    For more information, please contact the SVI Coordinator at
                    <a href="mailto:svi_coordinator@cdc.gov" className="icon-mail">
                        svi_coordinator@cdc.gov
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};
export default ContentInformation;
